module.exports = __webpack_public_path__ + "img/liftBelowBtn.4a6139de.png";